/**
 * SINGLETON Socket.IO client. Import this everywhere; never call io() in components.
 * Prefer websocket transport to avoid polling sid thrash behind proxies/load balancers.
 */
import { io } from "socket.io-client";
import { url } from "./Components/url";

const SOCKET_URL = (url || "http://127.0.0.1:5000").replace(/\/+$/, "");

export const socket = io(SOCKET_URL, {
  // Allow polling fallback behind hosted proxies/load balancers.
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  timeout: 10000,
  autoConnect: false,
  withCredentials: true,
});

socket.on("connect", () => {
  console.log("[Socket] connected:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log("[Socket] disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.warn("[Socket] connect_error:", err.message);
});
